import clsx from 'clsx';
import { formatTSh, type Product } from '@tangazo/shared';
import { useConfig } from '@/api/hooks';
import type { AppConfig } from '@/api/types';
import { useT } from '@/lib/i18n';

// "1 AI result + 3 more with your own changes", or the plain count when there are no iterations.
export function aiFeature(t: ReturnType<typeof useT>['t'], config: AppConfig | undefined, p: Product): string[] {
  const n = config?.aiTokens?.[p.id] ?? 0;
  const plan = config?.aiPlans?.[p.id];
  if (!n) return [];
  return [plan && plan.results && plan.iterations ? t('ai.plan_feature', { results: plan.results, iterations: plan.iterations }) : t('ai.tokens_feature', { n })];
}

export function PackageCard({ p, checked, name, onPick }: { p: Product; checked: boolean; name: string; onPick: () => void }) {
  const { t, tl } = useT();
  const config = useConfig();
  const features = [...aiFeature(t, config.data, p), ...tl(`product.${p.id}.features`)];
  return (
    <label className={clsx('relative block cursor-pointer rounded-[18px] border-2 bg-white px-4 py-3.5', checked ? 'border-brand ring-1 ring-brand' : 'border-line')}>
      <input type="radio" name={name} value={p.id} checked={checked} onChange={onPick} className="sr-only" />
      <span className="flex flex-wrap items-center gap-2">
        <span className="text-[1.05rem] font-bold">{t(`product.${p.id}.name`)}</span>
        {p.popular && <span className="rounded-full bg-ok px-2.5 py-0.5 text-xs font-bold text-white">{t('pay.popular')}</span>}
        <span className="ml-auto text-lg font-bold">{formatTSh(p.price)}</span>
      </span>
      <ul className="mt-1.5 list-disc pl-5 text-sm text-ink-2">
        {features.map((f) => <li key={f}>{f}</li>)}
      </ul>
    </label>
  );
}
